import { useCallback, useContext } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import ColorToolsContext from '../components/context/ColorToolsContext';
import { getAnalyticsTool, getAnalyticsUser, trackEvent } from '../utils/analytics';

const useAnalytics = () => {
    const { userFromClient } = useContext(ColorToolsContext);
    const { pathname } = useLocation();
    const tool = getAnalyticsTool(pathname);
    const { user_tier: userTier, active_subscription: activeSubscription } =
        getAnalyticsUser(userFromClient);

    return useCallback(
        (event, context = {}) =>
            trackEvent(event, {
                ...(tool ? { tool } : {}),
                user_tier: userTier,
                ...(activeSubscription === undefined
                    ? {}
                    : { active_subscription: activeSubscription }),
                ...context,
            }),
        [tool, userTier, activeSubscription],
    );
};

export default useAnalytics;
